import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import "./Css/View.css"
import profile from "./Images/Ellipse 24 (7).png";
import API_BASE from "../config/api";

const TeacherView = () => {
  const navigate = useNavigate();
  const { id } = useParams(); 
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL = `${API_BASE}`;

  useEffect(() => {
    fetchTeacher();
  }, [id]);

  const fetchTeacher = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/institute/teachers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          },
        }
      );
      setTeacher(res.data);
      console.log(res.data, 'data')
    } catch (err) {
      console.error(err);
      alert("Teacher not found");
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = () => {
    navigate(`/dashboard/teacheredit/${teacher.userId}`);
  };

  if (loading) return <p>Loading...</p>;
  if (!teacher) return null;

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन  &gt;&gt; तपशील &gt;&gt; शिक्षक माहिती &gt;&gt;<span>शिक्षक तपशील</span>
        </h3>
        <button className="edit-btn" onClick={() => handleEditClick()} >एडिट करा</button>
      </div>
      <p>संस्थेचे नाव: <strong>{teacher.instituteName}</strong></p>
      <h2>शिक्षक प्रोफाइल</h2>
      <div className="profile-card">
        <img
          src={
            teacher.profilePictureUrl
              ? `${API_BASE_URL}${teacher.profilePictureUrl}`
              : profile
          }
          alt="teacher"
          className="profile-img"
        />
      </div>

      {/* Info Grid */}
      <div className="info-grid">
        <div className="info-box">
          <label>शिक्षकाचे नाव</label>
          <p>{teacher.teacherName}</p>
        </div>
        <div className="info-box">
          <label>ईमेल</label>
          <p>{teacher.email}</p>
        </div>
        <div className="info-box">
          <label>मोबाईल नं.</label>
          <p>{teacher.phoneNumber ?? "-"}</p>
        </div>

        <div className="info-box">
          <label>नियुक्त इयत्ता</label>
          <p>{teacher.softwares.map(s => s.softwareName).join(", ")}</p>
        </div>

        <div className="info-box">
          <label>नियुक्त परीक्षेचे नाव </label>
          <p>{teacher.standards.map(s => s.name).join(", ")}</p>
        </div>

        <div className="info-box">
          <label>नियुक्त विषय   </label>
          <p>{teacher.subjects.map(s => s.name).join(", ")}</p>
        </div>
      </div>

      {/* Exam Table */}
      <div className="exam-section">
        <h2>शिक्षकाने घेतलेल्या परीक्षा</h2>

        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>परीक्षा नाव</th>
              <th>परीक्षा प्रकार </th>
              <th>इयत्ता</th>
              <th>विषय</th>
              <th>एकूण विद्यार्थ्यांची संख्या</th>
              <th>तारीख</th>
              <th>स्थिती</th>
            </tr>
          </thead>

          <tbody>
            {teacher.papers && teacher.papers.length > 0 ? (
              teacher.papers.map((paper, index) => (
                <tr key={paper.paperId}>
                  <td>{index + 1}</td>
                  <td>{paper.softwareName}</td>
                  <td>{paper.paperType}</td>
                  <td>{paper.standardName}</td>
                  <td>{paper.subjectName ?? "-"}</td>
                  <td>{paper.studentCount}</td>
                  <td>
                    {new Date(paper.createdDate).toLocaleDateString("mr-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </td>
                  <td className="pass">{paper.statusMarathi}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  कोणतीही परीक्षा उपलब्ध नाही
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeacherView;
